export default __webpack_public_path__ + "static/media/privacyPolicy_root_background.b1d7f32e.jpg";